import { axios } from 'src/app/Axios';
import { gql } from 'graphql-request';

import { graphqlRequest } from 'src/app/graphqlClient';
import { PricingBodInfo, PricingBodsResponse } from '../../shared/types';
import { EventServicePageNameTypes } from 'src/features/shared/ManageColumnsPopup/queries/apiTypes';
import { TableCol } from '../manufacturerViewTable/derived-types';

export const endpoints = {
    getPricingBodListUrl: (bomId: number) => `/bom/${bomId}/quote_metadata/`,
    getPricingBodEditUrl: (bomId: number, bodId: number) => `/bom/${bomId}/quote_metadata/${bodId}/`,
    getPricingStatsUrl: (bomId: number) => `/bom/${bomId}/statistics/pricing`
};

export function getPricingBods(bomId: number) {
    return axios.get<PricingBodsResponse>(endpoints.getPricingBodListUrl(bomId));
}

export function patchPricingBod({ bomId, bodId, pricingBod }: { bomId: number; bodId: number; pricingBod: Partial<PricingBodInfo>; shouldCancelQueries?: boolean }) {
    return axios.patch<PricingBodsResponse>(endpoints.getPricingBodEditUrl(bomId, bodId), pricingBod);
}

export const updateColumnsWidth = async (request: { pageName: EventServicePageNameTypes; widthPayload: Record<TableCol, number> }) => {
    const insertMutationString = gql`
        mutation upsertColumnsWidth($pageName: page_name_type!, $width: jsonb) {
            events_db {
                insert_table_settings(objects: { width: $width, page_name: $pageName }, on_conflict: { constraint: table_settings_pkey, update_columns: width }) {
                    affected_rows
                }
            }
        }
    `;
    const response = await graphqlRequest({
        document: insertMutationString,
        variables: { width: request.widthPayload, pageName: request.pageName }
    });
    return response.events_db;
};

export const updateColumnsOrder = async (request: { pageName: EventServicePageNameTypes; order: Array<TableCol> }) => {
    const insertMutationString = gql`
        mutation upsertColumnsOrderMutation($pageName: page_name_type!, $order: [String!]) {
            events_db {
                insert_table_settings(objects: { order: $order, page_name: $pageName }, on_conflict: { constraint: table_settings_pkey, update_columns: order }) {
                    affected_rows
                }
            }
        }
    `;
    const response = await graphqlRequest({
        document: insertMutationString,
        variables: { order: request.order, pageName: request.pageName }
    });
    return response.events_db;
};
